import React from 'react';
import type PlanSettingsSavedViewsType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/saved-views/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - saved-views page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsSavedViews = lazyForPaint<typeof PlanSettingsSavedViewsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-saved-views", jiraSpaEntry: "async-plan-settings-saved-views" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/saved-views'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyPlanSettingsSavedViews}
		pageId="plan-settings-saved-views"
		shouldShowSpinner
	/>
);
